import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {
  CensimentoDocumentiFormComponent
} from 'src/app/common/form/censimento-documenti-form/censimento-documenti-form.component';
import { SezioneCensimentoDocumentiResponse } from 'src/app/common/models/dto/sezione-censimento-document-response';
import { CensimentoDocumenti } from 'src/app/common/models/sezioni/sezione-censimento-documenti/censimento-documenti';
import {
  SezioneCensimentoDocumenti
} from 'src/app/common/models/sezioni/sezione-censimento-documenti/sezione-censimento-documenti';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [censimento-documenti-edit]',
  templateUrl: 'censimento-documenti-edit.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class CensimentoDocumentiEditComponent{
  @ViewChild('formCensimentoDocumentiAdd') formCensimentoDocumenti: CensimentoDocumentiFormComponent;

  @Output() onReturn: EventEmitter<any> = new EventEmitter<any>();

  inizializza(urlUpdate: string, idFascicolo: string, idSezione: string, sezione: SezioneCensimentoDocumenti, inserimento: boolean, censimento: CensimentoDocumenti) {
    this.formCensimentoDocumenti.inizializza(urlUpdate, idFascicolo, idSezione, sezione, inserimento, censimento);
    openModal('modalEditCensimentoDocumenti');
  }

  createForm() {
    this.formCensimentoDocumenti.createForm();
  }

  manageModal(response: SezioneCensimentoDocumentiResponse) {
    closeModal('modalEditCensimentoDocumenti');
    this.onReturn.emit(response);
  }
}
